import { useEffect, useState } from 'react';
import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { LoginDataSliceState } from '../store/logInDataSlice';

export const useAppWithLogInDataSelector: TypedUseSelectorHook<LoginDataSliceState> = useSelector;

export function useMaintenanceBanner() {
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    const fetchMaintenance = async () => {
      let uptimeMonitorId = 'QmAlWIXDVg';
      let uptimeMonitorPrefix = 'developstatus';
      if (process.env.APP_ENV === 'production') {
        uptimeMonitorId = 'Ao8zDUZVNp';
        uptimeMonitorPrefix = 'status';
      }

      const previous24Hours = Math.floor(Date.now() / 1000) - 86400;
      const next24Hours = Math.floor(Date.now() / 1000) - 86400;
      const monitorUrl = `https://${uptimeMonitorPrefix}.paragontruss.com/api/getEventFeed/${uptimeMonitorId}?from_date=${previous24Hours}&_=${next24Hours}`;

      try {
        const res = await fetch(monitorUrl);
        const data = await res.json();

        if (data.meta && data.meta.count !== 0) {
          setMessage(`${data.results[0].title ?? ''}`);
        }
      } catch (err) {
        console.error('Failed to fetch announcements:', err);
      }
    };

    fetchMaintenance();
  }, []);

  return message;
}
